import router from "@/router/index";

//Models
import currentCompanyModel from "@/domain/models/auth-models/current-company-model";
import currentUserModel from "@/domain/models/auth-models/current-user-model.js";
import facebookUserModel from "@/domain/models/auth-models/facebook-user.model.js";

//Service
import { getRemainingPointsByCompanyIdAndCurrentContactId } from "@/app/shared-components/navbar/service/navbar.service";
import { getSessionByCurrentId } from "@/domain/general-services/auth.service";

export default  {
    namespaced: true,
    state: {
        currentUser: {},
        currentCompany: {},
        facebookUser: {},
        token: null,
        sessionIdLoginControl: false
    },
    mutations: {
        to_log(state, passedCurrentUser) {
            if( passedCurrentUser ) {
                getRemainingPointsByCompanyIdAndCurrentContactId( state.currentCompany.id )
                    .then( success => {
                            state.currentCompany.remainingPoints = success.data.remainingPoints
                            if(state.sessionIdLoginControl) {
                                router.push( { path: '/perfil' } )
                                state.sessionIdLoginControl = false
                            }
                        }
                    )
                    .catch( error => {
                            if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                            }
                        }
                    )
                    
                state.token = passedCurrentUser.id
                state.currentUser = new currentUserModel(passedCurrentUser)
            }
        },
        logout(state) {
            state.currentUser = { }
            state.token = null
            router.push( { path: '/inicio' } )
        },
        setCurrentCompany(state, passedCurrentCompany) {
            state.currentCompany = new currentCompanyModel(passedCurrentCompany)
        },
        setRemainingPoints(state, passedRemainingPoints) {
            state.currentCompany.remainingPoints = passedRemainingPoints
        }
    },
    actions: {
        SESSION_LOGIN({commit, state}, sessionId) {
            let sessionToken = sessionId
            state.token = sessionToken
            
            getSessionByCurrentId(sessionToken)
                .then( success => {
                        state.sessionIdLoginControl = true
                        commit('to_log', success.data)
                    }
                )
                .catch( error => {
                    if (error != null) {
                        this.$toasted.show(error.message, { type: 'error' } )
                    }
                }
            )
        },
        TO_LOG({commit}, passedCurrentUser) {
            commit('to_log', passedCurrentUser)
        },
        LOGOUT({dispatch, commit}) {
            commit('logout')
            dispatch('RESET_ALL_STATE_EXCEPT_CURRENT_COMPANY', null, { root: true } )
        },
        FACEBOOK_SIGNUP(context) {
            return new Promise( (resolve,reject) => {
                    FB.login( function(response) {
                        if( response.status == 'connected' ) {
                            FB.api('/me', {fields: 'id,name,first_name,last_name,birthday,gender,email,picture.height(960).width(960)'}, function(userData) {
                                    if( userData ) {
                                        context.state.facebookUser = new facebookUserModel(response.authResponse, userData)
                                        resolve(context.state.facebookUser)
                                        
                                    } else {
                                        reject('userData not defined')
                                    }
                                }
                            )

                        } else reject('facebook login reject')
                    }, { scope: 'public_profile, email' } )
                }
            )
        },
        FACEBOOK_LOGIN() {
            return new Promise( (resolve, reject ) => {
                    FB.login( function(response) {
                        if( response.status == "connected" ) {
                            resolve(response.authResponse)

                        } else reject('Não foi possível entrar com o Facebook!')
                    }, { scope: 'public_profile, email' } )
                }
            )
        },
        FACEBOOK_LOGOUT() {
            return new Promise( ( resolve, reject ) => {
                    FB.getLoginStatus( function(response) {
                            if( response.status == 'connected') {
                                FB.logout( function() {
                                        state.facebookUser = {}
                                        resolve(true)
                                    }
                                )
                            } else reject('rejected')
                        }
                    )
                }
            ) 
        },
        SET_CURRENT_COMPANY({commit}, passedCurrentCompany) {
            commit('setCurrentCompany', passedCurrentCompany)
        },
        SET_REMAINING_POINTS({commit}, passedRemainingPoints) {
            commit('setRemainingPoints', passedRemainingPoints)
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        get_currentCompany: state => state.currentCompany,
        get_currentUserName: state => state.currentUser.userName,
        get_currentUserFirstName: state => (state.currentUser && state.currentUser.userName )? state.currentUser.userName.substring(0, state.currentUser.userName.indexOf(' ',1)) : null,
        get_currentCompanyPoints: state => state.currentCompany.remainingPoints,
        get_currentUserId: state => state.currentUser.userId,
        get_currentCompanyImage: state => state.currentCompany.image
    }
}